import React, { useState } from 'react';
import PropTypes from 'prop-types';

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

var YES_NO = 'YesNo';
var YES = 'YES';
var NO = 'NO';
var ON_OFF = 'OnOff';
var ON = 'ON';
var OFF = 'OFF';

var Switch = function Switch(_ref) {
  var disabled = _ref.disabled,
      label = _ref.label,
      labelAlignment = _ref.labelAlignment,
      onChange = _ref.onChange,
      statusText = _ref.statusText,
      props = _objectWithoutProperties(_ref, ["disabled", "label", "labelAlignment", "onChange", "statusText"]);

  var _useState = useState(props.status === true),
      _useState2 = _slicedToArray(_useState, 2),
      status = _useState2[0],
      setStatus = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      mouseOver = _useState4[0],
      setMouseOver = _useState4[1];

  var statusTextOptions = [];
  statusTextOptions[YES_NO] = [YES, NO];
  statusTextOptions[ON_OFF] = [ON, OFF];
  var statusTexts = statusTextOptions[statusText];

  var getStatusText = function getStatusText() {
    return status ? statusTexts[0] : statusTexts[1];
  };

  var labelAlign = function labelAlign() {
    if (labelAlignment === 'left') return 'align-left';else if (labelAlignment === 'right') return 'align-right';else if (labelAlignment === 'top') return 'align-top';
  };

  var handleClick = function handleClick() {
    handleChange();
  };

  var handleChange = function handleChange() {
    if (disabled) return;
    setStatus(!status);
    setMouseOver(false);
    onChange && onChange();
    return status === true;
  };

  var handleOnMouseOver = function handleOnMouseOver() {
    setMouseOver(true);
  };

  var handleOnMouseOut = function handleOnMouseOut() {
    setMouseOver(false);
  };

  var statusTextClassNames = function statusTextClassNames() {
    var classes = '';
    if (disabled === true) classes = ' disabled ';else if (status === true) classes = 'bold';
    return classes;
  };

  var getMouseOverClass = function getMouseOverClass() {
    var classPrefix = 'icon prism-icon-checkmark-circle';
    return mouseOver ? classPrefix + ' is-mouse-over' : classPrefix;
  };

  return /*#__PURE__*/React.createElement("div", {
    className: "switch ".concat(labelAlign())
  }, /*#__PURE__*/React.createElement("div", {
    role: "switch-label",
    className: "switch-label ".concat(labelAlign())
  }, label), /*#__PURE__*/React.createElement("div", {
    className: "switch-clickable",
    onMouseOver: handleOnMouseOver,
    onMouseOut: handleOnMouseOut
  }, /*#__PURE__*/React.createElement("label", {
    role: "switch-wrapper",
    className: "switch-wrapper ".concat(labelAlign())
  }, /*#__PURE__*/React.createElement("input", {
    "aria-label": "checkbox",
    disabled: disabled,
    type: "checkbox",
    onChange: handleChange,
    checked: status
  }), /*#__PURE__*/React.createElement("span", {
    className: "switch-track"
  }), /*#__PURE__*/React.createElement("span", {
    className: "switch-thumb ".concat(getMouseOverClass())
  })), /*#__PURE__*/React.createElement("label", {
    role: "switch-status-text",
    className: "switch-status-text ".concat(statusTextClassNames(), " ").concat(labelAlign()),
    onClick: handleClick
  }, getStatusText())));
};

var propTypes = {
  disabled: PropTypes.bool,
  label: PropTypes.string.isRequired,
  labelAlignment: PropTypes.oneOf(['top', 'left', 'right']).isRequired,
  onChange: PropTypes.func,
  status: PropTypes.bool,
  statusText: PropTypes.oneOf(['OnOff', 'YesNo']).isRequired
};
var defaultProps = {
  labelAlignment: 'left',
  disabled: false,
  label: '',
  status: false,
  statusText: 'YesNo'
};
Switch.propTypes = propTypes;
Switch.defaultProps = defaultProps;
Switch.YES_NO = YES_NO;
Switch.YES = YES;
Switch.NO = NO;
Switch.ON_OFF = ON_OFF;
Switch.ON = ON;
Switch.OFF = OFF;

export default Switch;
//# sourceMappingURL=index.esm.js.map
